import React, { useEffect } from 'react'
import Button from '../components/Button'
import RadioButtonQuestion from '../components/RadioButtonQuestion'
import {questions} from '../data/json'


const TestQuestions2 = ({prevStep, nextStep, handleChange, values, toResults}) => {
  
  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
    });
  }, [])
 
  const Continue = e => {
    e.preventDefault();
    nextStep();
  }

  const GoBack = e => {
    e.preventDefault();
    prevStep();
  }

  // const ToResults = e => {
  //   e.preventDefault();
  //   toResults();
  // }

  return (
    <div className='__test-questions'>
      <h2>Økonomi</h2>
      <p>Økonomisk modstandskraft er en nøglefaktor for at opbygge en modstandsdygtig virksomhed, da det handler om at sikre, at man har tilstrækkelige økonomiske ressourcer til at kunne modstå eventuelle kriser eller udfordringer. Dette kan f.eks. omfatte økonomistyring, en diversificeret indtægtsstrøm, en passende pengestrøm og en økonomisk fleksibilitet til at tilpasse sig ændrede markedsvilkår. </p> 
        <form>
          <RadioButtonQuestion values={values} isChecked={values.qst2_1} title={questions.economy.qst_1} name="qst-economy_1" onChange={handleChange('qst2_1')} />
          <RadioButtonQuestion values={values} isChecked={values.qst2_2} title={questions.economy.qst_2} name="qst-economy_2" onChange={handleChange('qst2_2')}  />
          <RadioButtonQuestion values={values} isChecked={values.qst2_3} title={questions.economy.qst_3} name="qst-economy_3" onChange={handleChange('qst2_3')} />
          <RadioButtonQuestion values={values} isChecked={values.qst2_4} title={questions.economy.qst_4} name="qst-economy_4" onChange={handleChange('qst2_4')} />
          <div className='__prev-next-buttons'>
            <Button buttonText='Tilbage' onClick={GoBack}  />
            <Button buttonText='Næste' onClick={Continue} disabled={(values.qst2_1 !== '' && values.qst2_2 !== '' && values.qst2_3 !== '' && values.qst2_4 !== '' ) ? false : true}  />
            {/* <Button buttonText='Resultat' onClick={ToResults}  /> */}
          </div>
        </form>
    </div>

  )
}

export default TestQuestions2